import { useState } from 'react';
import { EditorProps } from 'react-data-grid';
import { IMask, IMaskInput } from 'react-imask';

import { getDateStringWithTimeZone } from '@app/utils/dateUtils';
import { Row } from '@app/utils/epgUtils';
import dayjs from 'dayjs';

import './styles.css';

const textEditorClassname = `rdg-text-editor text-editor`;

function autoFocusAndSelect(input: HTMLInputElement | null) {
  input?.focus();
  input?.select();
  input?.setRangeText('', 0, input?.value?.length, 'start');
}

const dayjsFormat = 'HH:mm';
const EMPTY_MASK = '__:__';

export const TimeInputEditor = ({ row, column, onRowChange }: EditorProps<Row>) => {
  const [text, setText] = useState(row[column.key as keyof Row] as unknown as string);

  return (
    <IMaskInput
      mask={Date}
      className={textEditorClassname}
      value={text}
      pattern={dayjsFormat}
      alwaysShowMask={false}
      inputRef={autoFocusAndSelect}
      lazy={false}
      format={(date) => {
        return getDateStringWithTimeZone(date, dayjsFormat);
      }}
      parse={(str) => {
        return dayjs(str, dayjsFormat) as unknown as Date;
      }}
      onAccept={(value) => {
        if (value === EMPTY_MASK) {
          onRowChange({ ...row, [column.key]: '' });
        }
        setText(value as string);
      }}
      onComplete={(value) => {
        onRowChange({ ...row, [column.key]: value });
      }}
      blocks={{
        HH: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 23,
        },
        mm: {
          mask: IMask.MaskedRange,
          from: 0,
          to: 59,
        },
      }}
    />
  );
};
